import { BsShieldLock } from "react-icons/bs";
import { FiSend } from "react-icons/fi";
import CreatableSelect from "react-select/creatable";
import React, { useState, useRef, useEffect } from "react";
import { FaEdit, FaCheck } from "react-icons/fa";
import { HiOutlineBan } from "react-icons/hi";
import { RiFilePaperLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { AiOutlineDelete } from "react-icons/ai";
import Box from "common/Box";
import axios from "axios";
import ReactPaginate from "react-paginate";
import "./tabs.scss";
import sendRequest from "hooks/useAxios";

function Select({ value, Labels, filteredUsers }) {
  const [Tags, setTags] = useState([]);

  const UsersTag = (LinkedTag) => {
    LinkedTag.map((item) => {
      if (item.__isNew__) {
        let form = new FormData();
        form.append("title", `${item.label}`);
        axios
          .post("http://mvc.dade24.ir/api/Insert_user_tags", form)
          .then(({ data }) => {
            if (data.status) {
              let form = new FormData();
              form.append("user_tag_id", `${data.result.id}`);
              form.append("user_id", `${value.id}`);
              axios
                .post("http://mvc.dade24.ir/api/Insert_user_tag_links", form)
                .then(({ data }) => {
                  if (data.status) {
                  }
                })
                .catch((error) => {});
            }
          })
          .catch((error) => {});
      } else {
        if (!Tags.includes(item)) {
          let form = new FormData();
          form.append("user_tag_id", `${item.value}`);
          form.append("user_id", `${value.id}`);
          axios
            .post("http://mvc.dade24.ir/api/Insert_user_tag_links", form)
            .then(({ data }) => {
              if (data.status) {
              }
            })
            .catch((error) => {});
        }
      }
    });
    Tags.map((item) => {
      if (!LinkedTag.includes(item) && !item.__isNew__) {
        let form = new FormData();
        form.append("conditions", `user_tag_id/=/${item.value}@@user_id/=/${value.id}`);
        axios
          .post("http://mvc.dade24.ir/api/Delete_user_tag_links", form)
          .then(({ data }) => {
            if (data.status) {
            }
          })
          .catch((error) => {});
      }
    });
    setTags(LinkedTag);
  };

  useEffect(() => {
    let tags = [];
    value.linkedtag.forEach((element) => {
      if (
        tags.findIndex((value) => {
          return value.value == element.user_tag_id && value.label == element.title;
        }) == -1
      ) {
        tags.push({
          value: `${element.user_tag_id}`,
          label: `${element.title}`,
        });
      }
    });
    setTags(tags);
  }, [filteredUsers]);
  return (
    <>
      <CreatableSelect isMulti placeholder={"انتخاب"} options={Labels} value={Tags} className="text-dark user-label" onChange={(e) => UsersTag(e)} />
    </>
  );
}

export default function CustomerTab({ setUpdaterModal, UpdaterModal, setId, Pages, Labels, deleteUser, changeStatus, filteredUsers, setSelectedUserInformation, chosenPeople, setChosenPeople, User_Access, CountCustomers, FilterKey, FilterSend, pagination, setpagination }) {
  const [labels, setlabels] = useState("");
  const [labelsArray, setlabelsArray] = useState([]);
  const date = (TimeStamp) => {
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString("fa-IR", options);
    date.replace(/([۰-۹])/g, (token) => String.fromCharCode(token.charCodeAt(0) - 1728));
    return date;
  };

  function addChosen(id, email) {
    setChosenPeople((prev) => [...prev, [id, email]]);
  }

  function removeChosen(id) {
    setChosenPeople((prev) => prev.filter((value) => value[0] != id));
  }

  const Check = (chosenPeople, value) => {
    chosenPeople.map((item) => {
      if (item[0] == value["id"] && item[1] == value["email"]) {
        return true;
      } else {
        return false;
      }
    });
  };

  useEffect(() => {}, [filteredUsers]);

  const multipleOperations = useRef(null);
  var isGroupSelected = false;
  return (
    <>
      <div className="tab-pane fade p-5 Tabs" id="customers" role="tabpanel" aria-labelledby="customers-tab">
        <div className="row mx-auto">
          <div className="content p-1 mt-2 text-center  mx-auto multiple-operations">
            <div className="mx-auto">
              <span className="selected-number mx-1">{chosenPeople.length}</span>
              <span>کاربر انتخاب شده</span>
            </div>

            <button className="d-none" id="open-send-message-modal" data-bs-toggle="modal" data-bs-target="#send-message"></button>

            <button className="d-none" id="open-toggle-status-modal" data-bs-toggle="modal" data-bs-target="#toggle-status-modal"></button>

            <button className="d-none" id="open-change-label-modal" data-bs-toggle="modal" data-bs-target="#change-label"></button>

            <div className="mx-auto text-center d-flex justify-content-center mt-3">
              <div style={{ width: "150px" }}>
                <select className="mx-auto form-select " id="" ref={multipleOperations}>
                  <option value="" disabled hidden selected>
                    عملیات گروهی
                  </option>
                  <option value=""> برچسب</option>
                  <option value="">ارسال پیام</option>
                  <option value="">تغییر وضعیت</option>
                </select>
              </div>
              <div className="text-center mx-2">
                <button
                  className="btn btn-success "
                  onClick={() => {
                    isGroupSelected = true;
                    if (multipleOperations.current.selectedIndex == 1) {
                      document.querySelector("#open-change-label-modal").click();
                    } else if (multipleOperations.current.selectedIndex == 2) {
                      document.querySelector("#open-send-message-modal").click();
                    } else if (multipleOperations.current.selectedIndex == 3) {
                      document.querySelector("#open-toggle-status-modal").click();
                    }
                  }}
                >
                  اجرا
                </button>
              </div>
            </div>
          </div>
        </div>

        {filteredUsers &&
          filteredUsers.map((value, index) => {
            return (
              <Box
                key={index}
                information={[
                  [
                    "انتخاب",
                    <input
                      type="checkbox"
                      checked={Check(chosenPeople, value)}
                      className="mx-auto form-check-input"
                      onChange={(e) => {
                        if (e.target.checked) {
                          addChosen(value.id, value.email);
                        } else {
                          removeChosen(value.id, value.email);
                        }
                      }}
                    />,
                  ],
                  // ["ردیف",
                  //   value.id
                  // ],
                  [
                    "نام و نام خانوادگی",
                    <button
                      className="btn shadow-0 text-white"
                      onClick={() => {
                        setId(value.id);
                        setUpdaterModal(!UpdaterModal);
                      }}
                      data-bs-toggle="modal"
                      data-bs-target="#userInfo"
                    >
                      {value.fname + " " + value.lname}
                    </button>,
                  ],

                  ["شماره همراه", value.mobile],
                  ["وضعیت", parseInt(value.mainstatus) != 2 ? (parseInt(value.mainstatus) == 0 ? "فعال" : "فعال (رفع مسدودی)") : "غیر فعال"],
                  // ["امتیاز", value.score],
                  // ["خرید کل", value.total_buy],
                  ["کد ملی", value.codemeli],
                  ["تاریخ عضویت", date(value.mtm)],
                  ["برچسب", <Select value={value} Labels={Labels} filteredUsers={filteredUsers} />],
                  [
                    "عملیات",
                    <div className="icon  w-100 text-center tab-pane-hover">
                      <FaEdit
                        className="mx-1"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-user"
                        onClick={() => {
                          return setSelectedUserInformation(value);
                        }}
                        data-tip="ویرایش"
                      ></FaEdit>

                      {parseInt(value.mainstatus) != 2 ? (
                        <HiOutlineBan
                          className="mx-1 tab-pane-hover"
                          onClick={() => {
                            return changeStatus([parseInt(value.id)], parseInt(value.mainstatus) != 2 ? 2 : 1, 0);
                          }}
                          data-tip="تغییر وضعیت"
                        ></HiOutlineBan>
                      ) : (
                        <FaCheck
                          className="mx-1 tab-pane-hover"
                          onClick={() => {
                            return changeStatus([parseInt(value.id)], parseInt(value.mainstatus) != 2 ? 2 : 1, 0);
                          }}
                          data-tip="تغییر وضعیت"
                        ></FaCheck>
                      )}

                      {/* <NavLink target="_blank" to={`/admin-panel/user-report/${value.id}`} style={{ color: "white", textDecoration: "normal" }}>
                        <RiFilePaperLine className="mx-1" data-tip="گزارش"></RiFilePaperLine>
                      </NavLink> */}

                      {/* <AiOutlineDelete
                        className="mx-1 tab-pane-hover"
                        onClick={() => {
                          return deleteUser(parseInt(value.id));
                        }}
                        data-tip="حذف"
                      ></AiOutlineDelete> */}

                      {/* <BsShieldLock
                        className="mx-1 tab-pane-hover"
                        data-bs-toggle="modal"
                        data-bs-target="#access-level"
                        onClick={() => {
                          User_Access(value.id);
                          setSelectedUserInformation(value);
                        }}
                        data-tip="سطح دسترسی"
                      ></BsShieldLock> */}

                      <FiSend
                        className="mx-1 tab-pane-hover"
                        data-bs-toggle="modal"
                        data-bs-target="#send-message"
                        data-tip="ارسال پیام"
                        onClick={() => {
                          setSelectedUserInformation(value);
                        }}
                      ></FiSend>
                    </div>,
                  ],
                ]}
              ></Box>
            );
          })}

        <ReactPaginate
          forcePage={pagination}
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={Math.ceil(CountCustomers / 10)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={(e) => {
            !FilterKey ? Pages("iscustomer", e.selected + 1, 0) : FilterSend("iscustomer", e.selected + 1, 0);
            setpagination(e.selected);
          }}
          containerClassName="pagination mb-3 padding-x"
          activeClassName=" style-activeClass"
          activeLinkClassName="bg-info text-white "
          pageClassName="style-pageClass mx-2 pt-2"
          pageLinkClassName="page-link style-page-link py-1"
          nextClassName="border btn mx-1 p-0 mt-2 px-0 py-1 style-nextClass"
          previousClassName="border btn mx-1 p-0 mt-2 py-1 style-previousClass "
          nextLinkClassName="style-nextLink py-1 p-3 link-style"
          previousLinkClassName="style-previousLink py-1 p-3 link-style"
        />
      </div>
    </>
  );
}
